import ProfileInfoCard from './ProfileInfoCard'

export default ProfileInfoCard
